import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  50: '#E4E9F1',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  A100: '#33322f',
};

const NAVY = {
  0: '#3B3297',
  100: '#3B3297',
  200: '#3B3297',
  300: '#3B3297',
  400: '#3B3297',
  500: '#3B3297',
  600: '#2c2e7c',
  700: '#242567',
  800: '#1f2058',
  900: '#201d47',
};

const PRIMARY = {
  lighter: '#D1E9FC',
  light: '#76B0F1',
  main: '#3B3297',
  dark: '#103996',
  darker: '#061B64',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84A9FF',
  main: '#3366FF',
  dark: '#1939B7',
  darker: '#091A7A',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#4caf50',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const appEnvironmentColor = () => {
  const appEnv = process.env.REACT_APP_ENVIRONMENT;
  let color;
  console.log(appEnv, process.env.REACT_APP_ENVIRONMENT !== 'production')
  switch (appEnv) {
    case "development":
      const devColor = alpha(ERROR.darker, 0.95);
      color = {
        drawerBg: devColor,
        primaryMain: devColor,
        primartText: devColor,
      }
      break;
    case "staging":
      const stagingColor = alpha(WARNING.darker, 0.85);
      color = {
        drawerBg: stagingColor,
        primaryMain: stagingColor,
        primartText: stagingColor,
      }
      break;
    case "production":
    default:
      color = {
        drawerBg: GREY['A100'],
        primaryMain: alpha(GREY[800], 0.85),
        primartText: GREY[800],
      };
      break;
  }
  return color;
}

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY, main: appEnvironmentColor()?.primaryMain || '#3B3297', },
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  navy: NAVY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: appEnvironmentColor()?.primartText || GREY[800],
    secondary: NAVY[600],
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[50],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
  custom: {
    drawerBg: appEnvironmentColor()?.drawerBg || GREY['A100'],
  },
};


export default palette;
